import { ViewFormComponentDataService } from './../../view-form/shared/view-form-component-data.service';
import { find } from 'lodash';
import { DataSourceFormService } from './shared/data-source.form.service';
import {
  Component,
  OnInit,
  ViewChild,
  TemplateRef,
  Input,
  EventEmitter,
  Output,
  OnDestroy
} from '@angular/core';
import {
  BaseControl,
  SubForma,
  Forma,
  Option,
  TablaMaestra,
  OptionsColumns,
  FiltrosSelectores,
  Control
} from '@app/shared';
import { CreationFormDataService } from '../shared/creation-form-data.service';
import { CreationFormUtilsService } from '../shared/creation-form.utils.sevice';
import { Subject } from 'rxjs';

@Component({
  selector: 'iw-data-source',
  templateUrl: './data-source.component.html',
  styleUrls: ['./data-source.component.scss'],
  providers: [
    DataSourceFormService,
    ViewFormComponentDataService,
    CreationFormDataService,
    CreationFormUtilsService
  ]
})
export class DataSourceComponent implements OnInit, OnDestroy {

  // Identificador de el formulario
  @Input() formPrincipal: Forma;
  // Contiene la forma actual
  @Input() form: SubForma;
  // Contiene los campos del formulario actual
  @Input() controlsPalette: Control[];
  // Lista de tablas maestraas
  @Input() set masterTables(mt: TablaMaestra[]) {
    this.cfus.masterTables = mt;
  }
  // Contiene toodas las formas inplicadas en la forma actual e incluyendo esta
  @Input() allForms: Array<Option> = [];
  // Forma seleccionado
  formSelect = '';
  // Forma seleccionado
  typeSource = '';
  // subformulario seleccionado
  subFormSelect = '';
  // Contiene el id de la maestra dependencia seleccionada
  idMasterSelected = -1;
  // Contiene el id de la maestra a filtrar
  idMasterFilterSelected = -1;
  // Contine el id de la columna seleccionada
  columnSelected: any = null;
  // Contiene las opciones del formulario de los ngSelects para las tablas de formas
  options: any = {};
  // Contiene los formularios anteriormente cargados
  acumulateForm: any = {};
  // Controles del formulario de fuente de datos para las tablas
  controls: BaseControl<any>[] = [];
  // Opciones de las maestras
  masterOptions: Option[] = [];
  // Formularios de la forma seleccionada
  formularios: Option[] = [];
  // Campos del formulario seleccionada
  fields: Option[] = [];
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  columnsMaster: OptionsColumns[] = [];
  // Contine la informacion de las
  columnsMasterFilterData: OptionsColumns[] = [];
  columnsMasterFilterDataSelected: OptionsColumns[] = [];

  // contiene la inforamciond e los campos de la subforma seleccionada
  columnsSubFormSelect: any = [];
  // Contiene la informacion de las diferentes columnas de la maestra seleccionada
  columnsMasterFilter: OptionsColumns[] = [];
  // Contiene temporalmente los filtros del control selecionado
  tmpFilters: FiltrosSelectores[] = [];
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia a la plantilla para el control basico ng-select para el formulario
  @ViewChild('ngSelectFormulario') ngSelectFormulario: TemplateRef<any>;
  // Referencia a la plantilla para el control basico ng-select para el formulario
  @ViewChild('ngSelectMasterFields') ngSelectMasterFields: TemplateRef<any>;
  @Output() close: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private dsfs: DataSourceFormService,
    private vfcds: ViewFormComponentDataService,
    private cfds: CreationFormDataService,
    private cfus: CreationFormUtilsService
  ) { }

  async ngOnInit() {
    this.loadOptions();
    if (this.form && this.form.estilo['fuente'] && this.form.estilo['fuente']['form']) {
      if (this.form.estilo['fuente']['filtrar_registros']) {
        this.idMasterFilterSelected = this.form.estilo['fuente_filtro_maestra'];
        this.subFormSelect = this.form.estilo['fuente']['formulario'];
        this.formSelect = this.form.estilo['fuente']['form'];
        this.columnSelected = this.form.estilo['fuente_filtro'];
        this.columnsMasterFilterData = [];
        const master = await this.cfds.getInformacionMasterTable(this.idMasterFilterSelected);
        this.form.estilo['fuente_filtro_maestra'] = master.id;
        this.columnsMasterFilterData = this.cfus.loadingColumnsViews(
          master.estructura,
          this.idMasterFilterSelected,
          false
        );
        let structure: any[] = [];
        this.columnsMasterFilterData.forEach(element => {
          structure.push({
            key: element.value,
            value: element.column
          })
        })
        this.options['masterStructureFilter'] = structure;

        this.loadFormTable(this.form);

        this.columnsSubFormSelect = [];
        if (this.formPrincipal.alias == this.formSelect) {
          let subForm: any = find(this.formPrincipal.sub_formas, { alias: this.subFormSelect });
          if (subForm) {
            subForm.campos.forEach((element: any) => {
              this.columnsSubFormSelect.push({ alias: element.alias });
            })
          }
        } else if (this.acumulateForm && this.acumulateForm[this.formSelect]) {
          this.acumulateForm[this.formSelect].sub_formas.forEach((subForm: any) => {
            if (subForm.alias == this.subFormSelect) {
              subForm.campos.forEach((element: any) => {
                this.columnsSubFormSelect.push({ alias: element.alias });
              })
            }
          });
        };

      } else {
        this.loadFormTable(this.form);
      }
    } else if (this.form && this.form.estilo['fuente'] && this.form.estilo['fuente']['maestra']) {
      this.loadMasterTable(this.form);
    } else {
      this.refreshForm(this.form);
    }
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }

  trigger(callback: any, ...args: any[]) {
    return callback(...args);
  }

  get masterTables(): TablaMaestra[] {
    return this.cfus.masterTables;
  }

  /**
   * Cambios detectados en el formulario de fuente de datos
   *
   * @param {*} data
   * @memberof DataSourceComponent
   */
  async changeForm(data: any) {
    if (data.change) {
      const tmpData: any = {
        estilo: {
          fuente: {
            form: null,
            formulario: null,
            maestra: null,
            campos: null
          }
        },
      };
      if (data.change['cboTypeFount'] !== this.typeSource) {
        this.typeSource = data.change['cboTypeFount'];
        this.tmpFilters = [];
        if (this.form && this.form.estilo['fuente'] && this.form.estilo['fuente']['filtros']) {
          delete this.form.estilo['fuente']['filtros'];
        }
      }
      // Se valida si el tipo de carga de fuente seleccionada es diferente a la anterior
      // Para reiniciar las opciones de los selects
      if (data.change['cboForm'] && data.change['cboForm'] !== this.formSelect) {
        this.formSelect = data.change['cboForm'];
        tmpData['estilo']['fuente']['form'] = this.formSelect;
        this.loadFormTable(tmpData);
      } else if (data.change['cboMaster']) {
        // Se valida en que campo se realizo el cambio y se ejecuta las acciones pertinentes
        // Para cargar las opciones de los otros selects
        if (Number(data.change['cboMaster']) !== this.idMasterSelected) {
          this.formSelect = '';
          delete this.options['formularios'];
          this.formularios = [];
          this.idMasterSelected = Number(data.change['cboMaster']);
          this.columnsMaster = [];
          this.columnsMasterFilter = [];
          const master = await this.cfds.getInformacionMasterTable(this.idMasterSelected);
          this.columnsMaster = this.cfus.loadingColumnsViews(
            master.estructura,
            this.idMasterSelected,
            false
          );
          this.columnsMasterFilter = this.cfus.loadingColumnsViews(
            master.estructura,
            this.idMasterSelected,
            true
          );
          this.options['mastersStructure'] = this.columnsMaster;
          tmpData['estilo']['fuente']['maestra'] = master.id;
          tmpData['estilo']['fuente']['campos'] = data.change['cboFields'];

          this.refreshForm(tmpData);
        }
      } else if (data.change['cboFormulario'] && data.change['cboFormulario'] !== this.subFormSelect) {
        this.columnsSubFormSelect = [];
        this.subFormSelect = data.change['cboFormulario'];
        tmpData['alias'] = this.subFormSelect;
        tmpData['estilo']['fuente']['form'] = this.formSelect;
        tmpData['estilo']['fuente']['formulario'] = this.subFormSelect;
        if (this.formPrincipal.alias == this.formSelect) {
          let subForm: any = find(this.formPrincipal.sub_formas, { alias: this.subFormSelect });
          if (subForm) {
            subForm.campos.forEach((element: any) => {
              this.columnsSubFormSelect.push({ alias: element.alias });
            })
          }
        } else if (this.acumulateForm && this.acumulateForm[this.formSelect]) {
          this.acumulateForm[this.formSelect].sub_formas.forEach((subForm: any) => {
            if (subForm.alias == this.subFormSelect) {
              subForm.campos.forEach((element: any) => {
                this.columnsSubFormSelect.push({ alias: element.alias });
              })
            }
          });
        }
        tmpData['campos'] = this.columnsSubFormSelect;
        this.loadFormTable(tmpData);
      }
      else if (data.change['cboFormColumns'] && data.change['cboFormColumns'] !== this.columnSelected) {
        // Se valida en que campo se realizo el cambio y se ejecuta las acciones pertinentes
        // Para cargar las opciones de los otros selects
        this.columnSelected = data.change['cboFormColumns'];
        let masterId: any = null;
        this.form.campos.forEach(element => {
          if (element.tipo_campo.nombre == "ngSelect" && element.alias == this.columnSelected) {
            masterId = element.lista_maestra;
          }
        });
        if (masterId && masterId.length && masterId[0].id) {
          this.idMasterFilterSelected = masterId[0].id;
          this.columnsMasterFilterData = [];
          const master = await this.cfds.getInformacionMasterTable(this.idMasterFilterSelected);
          this.form.estilo['fuente_filtro_maestra'] = master.id;
          this.columnsMasterFilterData = this.cfus.loadingColumnsViews(
            master.estructura,
            this.idMasterFilterSelected,
            false
          );
          let structure: any[] = [];
          this.columnsMasterFilterData.forEach(element => {
            structure.push({
              key: element.value,
              value: element.column
            })
          })
          this.options['masterStructureFilter'] = structure;
          //this.refreshForm(this.form);
        }
        tmpData['alias'] = this.subFormSelect;
        tmpData['campos'] = this.columnsSubFormSelect;
        tmpData['estilo']['fuente']['form'] = this.formSelect;
        tmpData['estilo']['fuente']['formulario'] = this.subFormSelect;
        tmpData['estilo']['fuente']['filtrar_registros'] = true;
        tmpData['estilo']['fuente_filtro'] = this.columnSelected;
        tmpData['estilo']['fuente_filtro_maestra'] = this.idMasterFilterSelected;
        this.refreshForm(tmpData);

      }
    }
  }

  /**
   * Guarda los filtros agregadas al control
   *
   * @param {Array<FiltrosSelectores>} filters
   * @memberof DataSourceComponent
   */
  savedFilters(filters: Array<FiltrosSelectores>) {
    this.tmpFilters = filters;
  }

  /**
   * Guarda la creacion o edicion de la fuente de datos
   *
   * @param {*} data
   * @memberof DataSourceComponent
   */
  saved(data: any) {
    const fount = {};
    if (!data.chModificar === null) {
      data.chModificar = false;
    }
    if (data.chEliminar === null) {
      data.chEliminar = false;
    }

    fount['modificar_registros'] = data.chModificar;
    fount['eliminar_registros'] = data.chEliminar;

    if (data.cboForm) {
      fount['form'] = data.cboForm;
      fount['formulario'] = data.cboFormulario;
      fount['filtrar_registros'] = data.chFiltrar;

      this.form.estilo['fuente_filtro'] = data.cboFormColumns;
      this.form.estilo['fuente_filtro_maestra'] = data.cboMasterColumn;
      this.form.estilo['fuente_filtro_maestra_estructura'] = data.cboStructureMasterFiltred;
      this.form.estilo['filtro_valor'] = data.cboFiltredValue;

      fount['fuente_filtro'] = data.chFiltrar;
      fount['filtrar_registros'] = data.chFiltrar;
    } else if (data.cboMaster) {
      fount['maestra'] = data.cboMaster;
      fount['estructura'] = data.cboStructureMaster;
      fount['campos'] = data.cboFields;
      fount['filtros'] = this.tmpFilters;
    }
    if (this.form && this.form.estilo) {
      this.form.estilo['fuente'] = fount;
    } else {
      this.form.estilo = {
        fuente: fount
      };
    }
    this.close.emit(true);
  }

  /**
   * Carga las opciones por defecto del formulario
   *
   * @private
   * @memberof DataSourceComponent
   */
  private loadOptions() {
    if (this.controlsPalette && this.controlsPalette.length) {
      this.controlsPalette.forEach(field => {
        this.fields.push({
          key: field.alias,
          value: field.alias
        });
      });
    }
    if (this.form) {
      if (this.form.estilo['fuente']) {
        if (this.form.estilo['fuente']['form']) {
          this.formSelect = this.form.estilo['fuente']['form'];
        }
      }
    }
    if (this.masterTables && this.masterTables.length) {
      this.masterTables.forEach(master => {
        this.masterOptions.push({
          key: master.id,
          value: master.nombre
        });
      });
    }
    this.options = {
      forms: this.allForms,
      masters: this.masterOptions,
      fields: this.fields
    };
  }

  /**
   * Consulta los formularios de la forma seleccionada para las opciones del  campo de seleccion de forma
   * Acumula los formularios para proximos llamados a la misma forma
   *
   * @private
   * @param {(SubForma)} form
   * @memberof DataSourceComponent
   */
  private loadFormTable(form: SubForma) {
    this.formularios = [];
    const association = find(this.formPrincipal.asociaciones, { aliasAsociacion: this.formSelect });
    if (this.formPrincipal.alias === this.formSelect) {
      this.formPrincipal.sub_formas.forEach(subForm => {
        if (subForm.tabla && (this.form || subForm.alias !== this.form.alias)) {
          if (subForm.alias) {
            this.formularios.push({
              key: subForm.alias,
              value: subForm.nombre,
            });
          }
        }
      });
      this.options['formularios'] = this.formularios;
      this.refreshForm(form);
      this.typeSource = 'TablaForma';
    } else if (association) {
      const formSeleted: Forma = this.acumulateForm[this.formSelect];
      if (!formSeleted) {
        this.vfcds.getForm(association.idForma).subscribe(formA => {
          this.acumulateForm[this.formSelect] = formA;
          formA.sub_formas.forEach(subForm => {
            if (subForm.tabla) {
              if (subForm.alias) {
                this.formularios.push({
                  key: subForm.alias,
                  value: subForm.nombre,
                });
              }
            }
          });
          this.options['formularios'] = this.formularios;
          this.refreshForm(form);
          this.typeSource = 'TablaForma';
        });
      } else {
        formSeleted.sub_formas.forEach(subForm => {
          if (subForm.tabla) {
            if (subForm.alias) {
              this.formularios.push({
                key: subForm.alias,
                value: subForm.nombre,
              });
            }
          }
        });
        this.options['formularios'] = this.formularios;
        this.refreshForm(form);
        this.typeSource = 'TablaForma';
      }
    } else {
      this.options['formularios'] = this.formularios;
      this.refreshForm(form);
      this.typeSource = 'TablaForma';
    }
  }

  /**
   * Carga inicialmente el formulario con la configuracion seleccionada
   * para fuente de tipo tabla maestra
   *
   * @private
   * @param {SubForma} form
   * @memberof DataSourceComponent
   */
  private async loadMasterTable(form: SubForma) {
    if (form.estilo['fuente']['maestra']) {
      // Se valida en que campo se realizo el cambio y se ejecuta las acciones pertinentes
      // Para cargar las opciones de los otros selects
      if (Number(form.estilo['fuente']['maestra']) !== this.idMasterSelected) {
        this.formSelect = '';
        delete this.options['formularios'];
        this.formularios = [];
        this.idMasterSelected = Number(form.estilo['fuente']['maestra']);
        this.columnsMaster = [];
        this.columnsMasterFilter = [];
        const master = await this.cfds.getInformacionMasterTable(this.idMasterSelected);
        this.columnsMaster = this.cfus.loadingColumnsViews(
          master.estructura,
          this.idMasterSelected,
          false
        );
        this.columnsMasterFilter = this.cfus.loadingColumnsViews(
          master.estructura,
          this.idMasterSelected,
          true
        );
        this.options['mastersStructure'] = this.columnsMaster;

        this.refreshForm(form);
        this.typeSource = 'TablaMaestra';
      }
    }
  }

  /**
   * Refreca el formulario de creacion o edicion de fuente de datos
   *
   * @private
   * @param {SubForma} form
   * @memberof DataSourceComponent
   */
  private refreshForm(form: SubForma) {
    this.controls = this.dsfs.getFormFountDataTable(
      form,
      this.options,
      {
        ngSelectOnly: this.ngSelectFormulario,
        ngSelectMultipleMaster: this.ngSelectMasterFields
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/creation-dynamic-component/creation-form/data-source/data-source.component.ts